import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DbRecord } from '../db-record'
import { RuntimeService } from '../runtime.service'
import { DbRecordService } from '../db-record.service'
import { ExportItem } from '../export-item'

@Component({
  selector: 'app-edit-db-record-box',
  templateUrl: './edit-db-record-box.component.html',
  styleUrls: ['./edit-db-record-box.component.css']
})
export class EditDbRecordBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord
  _type: string
  _title: string
  _abstract: string
  _year: string
  _source: string
  _volume: string
  _issue: string
  _startPage: string
  _endPage: string
  _doi: string
  _url: string
  _note: string
  private _names = ["title", "abstract", "year", "source", "volume", "issue",
    "startPage", "endPage", "doi", 'url', 'type']

  private types = ['article', 'web']

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rts: RuntimeService,
    private dbrs: DbRecordService
  ) { }

  ngOnInit() {
    if (this.dbRecord)
      this._names.forEach(x => this[x] = this.dbRecord[x])
    else
      this.route.params.subscribe(params => {
        this.dbRecord = this.dbrs.newManual()
      })
  }

  cancel() {
    this.dbrs.cancelSave(this.dbRecord)
  }

  save() {
    let ei = new ExportItem({ tp: 'manual' })
    this._names.forEach((x) => ei[x] = this[x])

    this.dbRecord.update(ei.export(true))
    this.dbrs.save(this.dbRecord)
  }

  get type() {
    return this._type
  }

  set type(txt) {
    this._type = txt
  }

  get title() {
    return this._title
  }

  set title(txt) {
    this._title = txt
  }

  get abstract() {
    return this._abstract
  }

  set abstract(txt) {
    this._abstract = txt
  }

  get year() {
    return this._year
  }

  set year(txt) {
    this._year = txt
  }

  get source() {
    return this._source
  }

  set source(txt) {
    this._source = txt
  }

  get volume() {
    return this._volume
  }

  set volume(txt) {
    this._volume = txt
  }

  get issue() {
    return this._issue
  }

  set issue(txt) {
    this._issue = txt
  }

  get startPage() {
    return this._startPage
  }

  set startPage(txt) {
    this._startPage = txt
  }

  get endPage() {
    return this._endPage
  }

  set endPage(txt) {
    this._endPage = txt
  }

  get doi() {
    return this._doi
  }

  set doi(txt) {
    this._doi = txt
  }

  get note() {
    return this._note
  }

  set url(txt) {
    this._url = txt
  }

  get url() {
    return this._url
  }

  set note(txt) {
    this._note = txt
  }

}



// WEBPACK FOOTER //
// ./src/app/edit-db-record-box/edit-db-record-box.component.ts